import { ref } from 'vue';

/**
 * Composable genérico para adjuntos con Element Plus <el-upload>
 * - Sube archivos al backend (uploadPublicFileHTTP)
 * - Mantiene fileList para mostrar/descargar
 */
export function useAdjuntosUpload({ uploadPublicFileHTTP, apiBase, adapter }) {
  const fileList = ref([]);

  const API_BASE = apiBase || '';
  const PUBLIC_BASE = API_BASE ? API_BASE.replace(/\/api\/?$/, '') : '';

  const toRel = (u = '') => {
    if (!u) return '';
    const m = u.match(/\/assets\/(.+)$/i);
    if (m) return m[1];
    return u.replace(/^\/+/, '');
  };

  const toPublicUrl = (u = '') => {
    if (!u) return '';
    if (/^https?:\/\//i.test(u)) return u;

    const rel = toRel(u);
    const path = `/assets/${rel.replace(/^\/+/, '')}`;

    return PUBLIC_BASE ? `${PUBLIC_BASE}${path}` : path;
  };

  const ensureAdjuntos = () => {
    const list = adapter.getAdjuntos();
    if (Array.isArray(list)) return list;
    adapter.setAdjuntos([]);
    return adapter.getAdjuntos();
  };

  const reindex = (adj) => {
    adj.forEach((a, i) => (a.ItemAdjunto = i + 1));
  };

  const hydrateFileListFromModel = () => {
    const adj = adapter.getAdjuntos() || [];
    fileList.value = adj
      .filter((a) => a && a.Url)
      .map((a) => {
        const rel = toRel(a.Url);
        const name = rel.split('/').pop() || rel;
        return { name, url: toPublicUrl(rel), status: 'success' };
      });
  };

  const uploadAdjunto = async ({ file, onSuccess, onError }) => {
    try {
      const subdir = adapter.getSubdir();
      const payload = await uploadPublicFileHTTP({ subdir, file });

      const relPath = toRel(payload.url);

      const adj = ensureAdjuntos();
      // dedupe por relPath
      const exists = adj.some((a) => toRel(a?.Url || '') === relPath);
      if (!exists) {
        adj.push(
          adapter.buildAdjunto({
            relPath,
            nextItem: adj.length + 1,
            payload,
          }),
        );
        reindex(adj);
        adapter.setAdjuntos([...adj]);
      }

      fileList.value = [
        ...fileList.value,
        { name: file.name, url: toPublicUrl(relPath), status: 'success' },
      ];

      onSuccess && onSuccess(payload);
    } catch (err) {
      console.error('uploadAdjunto error:', err);
      onError && onError(err);
    }
  };

  const handleRemove = (file, currentFiles) => {
    fileList.value = currentFiles;
    const adj = ensureAdjuntos();
    const fname = (file?.name || '').toLowerCase();

    const idx = adj.findIndex((item) => {
      const rel = toRel(item?.Url || '');
      return (rel.split('/').pop() || '').toLowerCase() === fname;
    });

    if (idx !== -1) {
      adj.splice(idx, 1);
      reindex(adj);
      adapter.setAdjuntos([...adj]);
    }
  };

  return {
    fileList,
    uploadAdjunto,
    handleRemove,
    hydrateFileListFromModel,
    toRel,
    toPublicUrl,
  };
}
